import { createReducer, on } from '@ngrx/store';
import * as UserProfileActions from './user-profile.actions';
import { initialState } from './user-profile.state';

export const userProfileReducer = createReducer(
  initialState,

  // User Profile Loading
  on(UserProfileActions.userProfileRequest, state => ({
    ...state,
    apiState: 'Loading' as const,
  })),

  on(UserProfileActions.userProfileResponse, (state, { fachlektorMerkmale, lieferantenMerkmale, clientInfo, favouriteMerkmale }) => ({
    ...state,
    fachlektorMerkmale,
    lieferantenMerkmale,
    clientInfo,
    favouriteMerkmale,
    apiState: 'Success' as const,
  })),

  on(UserProfileActions.userProfileError, (state, { error }) => ({
    ...state,
    apiState: 'Failed' as const,
  })),

  // Favorite Merkmale
  on(UserProfileActions.addFavoriteMerkmalSuccess, (state, { favoriteMerkmal }) => {
    let favoriteMerkmale = [...state.favouriteMerkmale];
    favoriteMerkmale = favoriteMerkmale.filter(m => m.key !== favoriteMerkmal.key);
    return {
      ...state,
      favouriteMerkmale: [...favoriteMerkmale, favoriteMerkmal],
    };
  }),

  on(UserProfileActions.setFavoriteMerkmale, (state, { newFavoriteMerkmale }) => ({
    ...state,
    favouriteMerkmale: [...newFavoriteMerkmale],
  })),

  // Client Info
  on(UserProfileActions.loadClientInfoSuccess, state => ({
    ...state,
    apiState: 'Success' as const,
  })),

  on(UserProfileActions.loadClientInfoError, state => ({
    ...state,
    apiState: 'Failed' as const,
  })),

  on(UserProfileActions.saveClientInfoSuccess, state => ({
    ...state,
    apiState: 'Success' as const,
  })),

  on(UserProfileActions.saveClientInfoError, state => ({
    ...state,
    apiState: 'Failed' as const,
  })),

  // Load Favoriten
  on(UserProfileActions.loadFavoriten, state => ({
    ...state,
    isFavoritenLoading: true,
  })),

  on(UserProfileActions.loadFavoritenSuccess, (state, { favoriten }) => ({
    ...state,
    favoriten,
    isFavoritenLoading: false,
  })),

  on(UserProfileActions.loadFavoritenFailure, (state, { }) => ({
    ...state,
    isFavoritenLoading: false,
  })),

  // Add Favorit
  on(UserProfileActions.addFavorit, state => ({
    ...state
  })),

  on(UserProfileActions.addFavoritSuccess, (state, { favorit }) => ({
    ...state,
    favoriten: [...state.favoriten, favorit],
  })),

  on(UserProfileActions.addFavoritFailure, (state, { }) => ({
    ...state
  })),

  // Remove Favorit
  on(UserProfileActions.removeFavorit, state => ({
    ...state
  })),

  on(UserProfileActions.removeFavoritSuccess, (state, { objektTyp, objektId }) => ({
    ...state,
    favoriten: state.favoriten.filter(
      f => !(f.objektTyp === objektTyp && f.objektId === objektId)
    )
  })),

  on(UserProfileActions.removeFavoritFailure, (state, { }) => ({
    ...state
  })),

  // Check Favorit
  on(UserProfileActions.checkFavorit, state => ({
    ...state,
    isCheckingFavorit: true,
  })),

  on(UserProfileActions.checkFavoritSuccess, (state, { objektTyp, objektId, favorit }) => {
    // Always filter out the existing favorit with matching objektTyp/objektId
    const filteredFavoriten = state.favoriten.filter(
      f => !(f.objektTyp === objektTyp && f.objektId === objektId)
    );
    
    // If favorit is not null, add it; otherwise just return filtered array
    return {
      ...state,
      favoriten: favorit ? [...filteredFavoriten, favorit] : filteredFavoriten,
      isCheckingFavorit: false,
    };
  }),

  on(UserProfileActions.checkFavoritFailure, (state, { }) => ({
    ...state,
    isCheckingFavorit: false,
  }))
);
